import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactRouterPropTypes from "react-router-prop-types";

import { getModalBasePath } from "../../shared/utils";
import { resources, services } from "../actions";
import ServicesListItem from "../components/ServicesListItem";
import { ProductShape, ServiceShape } from "../proptypes";
import selectors from "../selectors";

const ServicesListGroup = ({
  product,
  services,
  currentService,
  selectService,
  location
}) => {
  const serviceItems = services.map(service => {
    const listItem = (
      <ServicesListItem
        service={service}
        key={service.$uri}
        onServiceClicked={selectService(service)}
        selected={currentService && service.$uri === currentService.$uri}
      />
    );
    if (location.pathname.includes("services")) {
      return (
        <Link
          key={service.$uri}
          to={`${getModalBasePath(location)}/${service.name}`}
        >
          {listItem}
        </Link>
      );
    }
    return listItem;
  });

  return (
    <li className="p-list__item">
      <div style={{ padding: ".3125rem .5rem" }}>{product.name}</div>
      <ul className="p-list">{serviceItems}</ul>
    </li>
  );
};

ServicesListGroup.propTypes = {
  product: ProductShape.isRequired,
  services: PropTypes.arrayOf(ServiceShape).isRequired,
  currentService: ServiceShape,
  selectService: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location.isRequired
};

ServicesListGroup.defaultProps = {
  currentService: undefined
};

const mapDispatchToProps = dispatch => ({
  selectService(service) {
    return () => {
      dispatch(services.setCurrent(service.$uri));
      dispatch(resources.setFirstInService(service.$uri));
    };
  }
});

const mapStateToProps = state => ({
  currentService: selectors.services.getCurrent(state),
  location: state.router.location
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesListGroup);
